import React, {useEffect} from "react";
import {BotForm, BotRequestPartial} from "./createAndUpdate/BotForm";
import {
    clearCreateBotState,
    createBot,
    createBotErrorMessageSelector,
    createBotRequestSelector,
    createBotRequestStatusSelector,
    updateCreateBotRequest
} from "../botCreateSlice";
import {createBotRequestPropertySelector} from "./selector/BotStoreSelector";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {fetchBotList} from "../botListSlice";
import {Loader} from "../../../elements/loader/Loader";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";
import {fetchFranchises, franchiseOptionsSelector, franchiseListStatusSelector} from "../../franchise/franchiseSlice";
import {SelectOption} from "../../../elements/select/SelectDropdown";
import {FranchiseRequestUi} from "../franchiseTypes";

interface CreateBotFormProps {
    handleClose: () => void
}

export const CreateBotForm: React.FC<CreateBotFormProps> = ({handleClose}) => {

    const dispatch = useAppDispatch()
    const franchises = useAppSelector(franchiseOptionsSelector)
    const createBotRequestStatus = useAppSelector(createBotRequestStatusSelector)
    const franchiseListStatus = useAppSelector(franchiseListStatusSelector)
    const errorMessage = useAppSelector(createBotErrorMessageSelector)

    useEffect(() => {
        dispatch(fetchFranchises())
        return () => {
            dispatch(clearCreateBotState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (createBotRequestStatus === RequestStatus.RESOLVED) {
            dispatch(fetchBotList())
            handleClose()
            dispatch(showSuccessToastNotification({message: "Assistant Created Successfully"}))
        } else if (createBotRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: errorMessage || "Failed to create assistant"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createBotRequestStatus]);


    useEffect(() => {
        if (franchiseListStatus === RequestStatus.REJECTED) {
            // Without franchises the form cannot be filled in, and the render below would otherwise
            // sit on a loader for ever. The thunk has already reported why.
            handleClose()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [franchiseListStatus]);

    if (franchiseListStatus === RequestStatus.RESOLVED) {
        const franchiseOptions: SelectOption<FranchiseRequestUi>[] = franchises.map(franchise => ({
            value: franchise,
            label: franchise.name
        }));

        const updateRequest = (update: BotRequestPartial) => {
            dispatch(updateCreateBotRequest(update))
        }

        const onSubmit = () => {
            dispatch(createBot())
        }

        return <BotForm
            formTitle={"Create assistant"}
            onClose={handleClose}
            onSubmit={onSubmit}
            updateRequest={updateRequest}
            franchiseOptions={franchiseOptions}
            selectionProvider={createBotRequestPropertySelector(createBotRequestSelector)}
        />
    } else {
        return <Loader/>
    }
}
